const delay = (milliseconds: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });

const download = async (url: string, name = '') => {
  const a = document.createElement('a');

  a.download = name;
  a.href = url;
  a.style.display = 'none';
  document.body.append(a);
  a.click();

  // Chrome requires the timeout
  await delay(100);
  a.remove();
};

export default async function multiDownload(urls: string[]) {
  if (!urls) {
    throw new Error('`urls` required');
  }

  for (const [index, url] of urls.entries()) {
    // 동시요청 방지
    await delay(index * 100);
    await download(url, `file-${index}.png`);
  }
}
